import { useContext } from 'react';
import { SupportBUContext } from './internal';
import { SupportBU } from './supportBU';

/**
 * Get the current user object (or null if not logged in)
 *
 * Does not redirect to login
 * @see {@link useAuthedUser}
 */
export function useSupportBU(): SupportBU | null {
  return useContext(SupportBUContext);
}
